import * as XLSX from "sheetjs-style";
export const exportToExcel = (data, fileName, sheetName = "Sheet1", mainHeader, columnHeaders) => {
  if (!mainHeader || !columnHeaders) {
    console.error("Main header and column headers are required!");
    return;
  }

  // Convert column headers into an object with keys
  const headersObject = columnHeaders.reduce((acc, col) => {
    acc[col.key] = col.label;
    return acc;
  }, {});

  // Format the data dynamically based on column headers
  const formattedData = data.map((row) =>
    Object.fromEntries(columnHeaders.map(({ key }) => [key, row[key] || ""]))
  );

  // Prepare final data with the main header row + column headers + data
  const finalData = [{ [Object.keys(headersObject)[0]]: mainHeader }, headersObject, ...formattedData];

  // Convert to worksheet
  const ws = XLSX.utils.json_to_sheet(finalData, { skipHeader: true });

  // Merge main header row across all columns
  ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: columnHeaders.length - 1 } }];

  // Apply styles to main header
  const firstCell = XLSX.utils.encode_cell({ r: 0, c: 0 });
  ws[firstCell].s = {
    font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "1E3A8A" } },
    alignment: { horizontal: "center", vertical: "center" },
  };

  // Apply styles to column headers
  columnHeaders.forEach((_, index) => {
    const cell = XLSX.utils.encode_cell({ r: 1, c: index });
    if (ws[cell]) {
      ws[cell].s = {
        font: { bold: true, color: { rgb: "FFFFFF" } },
        fill: { fgColor: { rgb: "A9A9A9" } },
        alignment: { horizontal: "center", vertical: "center", wrapText: true },
      };
    }
  });

  // Apply wrap text formatting to the "certifications" column data cells.
  applyWrapText(ws, columnHeaders, "certifications");

  // Set dynamic column widths based on labels
  ws["!cols"] = columnHeaders.map(({ width }) => ({ wch: width || 20 }));

  // Freeze Header Rows (Main Header + Column Headers)
  ws["!freeze"] = { xSplit: 0, ySplit: 2 };

  // Create a new workbook and append the sheet
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  // Write to file
  XLSX.writeFile(wb, fileName);
};


/**
 * Apply wrap text formatting to a specific column in the worksheet.
 * @param {Object} ws - The worksheet object
 * @param {Array} columnHeaders - The column headers array
 * @param {String} columnKey - The key of the column that needs wrap text
 */
export const applyWrapText = (ws, columnHeaders, columnKey) => {
  const columnIndex = columnHeaders.findIndex(col => col.key === columnKey);

  if (columnIndex !== -1) {
    const columnLetter = XLSX.utils.encode_col(columnIndex);

    // Loop through all data rows (starting after the header row)
    for (let rowIndex = 2; rowIndex <= ws["!ref"].split(":")[1].match(/\d+/)[0]; rowIndex++) {
      const cellAddress = `${columnLetter}${rowIndex}`;

      if (ws[cellAddress]) {
        // Merge wrapText with existing styles
        if (!ws[cellAddress].s) {
          ws[cellAddress].s = {};
        }
        if (!ws[cellAddress].s.alignment) {
          ws[cellAddress].s.alignment = {};
        }
        ws[cellAddress].s.alignment.wrapText = true;
      }
    }
  }
};
